<template>
  <img
    :src="src || config.public.strapiUrl + url"
    :alt="alt || caption || alternativeText || name"
    :width="width"
    :height="height"
    :loading="loading"
    v-bind="$attrs"
  />
</template>

<script setup lang="ts">
  const config = useRuntimeConfig()

  defineProps<{
    name?: string
    caption?: string
    alternativeText?: string
    url?: string
    src?: string
    loading?: "eager" | "lazy"
    alt?: string
    height?: number | string
    width?: number | string
  }>()
</script>
